module.exports = "/_next/static/resources/life2-da5d35afaf66cf5803a4d3f1fa9df2a2.jpg";